import React from "react";
import ImagingPopup from "./imaging";

const ImagingModal = ({ imagingmodal, data, dob, setImagingModal }) => {
  if (!imagingmodal) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      {/* <div className="bg-white rounded-md w-full max-w-2xl shadow-lg relative"> */}
        <ImagingPopup
          data={{ ...data, ...(dob && { dob }) }}
          setImagingModal={setImagingModal}
        />
      {/* </div> */}
    </div>
  );
};

export default ImagingModal;
